import React, { useState } from 'react'
import { CopyToClipboard } from 'react-copy-to-clipboard'
import { Button, Icon, Text } from '@planningcenter/tapestry-react'

export default function CopyPath({ path }) {
  const [copied, setCopied] = useState(false)
  return (
    <CopyToClipboard text={path} onCopy={() => setCopied(true)}>
      <Button
        theme={copied ? 'primary' : 'plain'}
        size="sm"
        marginLeft={1}
        onMouseLeave={() =>
          setTimeout(() => {
            setCopied(false)
          }, 2000)
        }
      >
        <Icon
          name={
            copied
              ? 'general.outlinedCircleCheck'
              : 'general.outlinedTwoBlankFiles'
          }
          marginRight={0.5}
        />
        <Text weight={400} size={4}>
          {copied ? 'Copied' : 'Copy'}
        </Text>
      </Button>
    </CopyToClipboard>
  )
}
